<div class="content-wrapper">
  <div class="header-wrapper">
    <h2>
      @if (site) {
        Send Email To {{ site.name }}
      } @else {
        Send Email
      }
    </h2>
    <button
      (click)="sendEmail()"
      [disabled]="emailForm.invalid"
      class="send-email-button"
      color="primary"
      mat-flat-button>
      Send Email
      <fa-icon [icon]="['fas', 'paper-plane']"></fa-icon>
    </button>
  </div>
  <form [formGroup]="emailForm" class="email-form">
    <mat-form-field class="w-100-1">
      <mat-label>Recipients</mat-label>
      <mat-chip-grid #recipientsChips aria-label="Recipients">
        @for (recipient of recipients; track recipient) {
          <mat-chip-row (removed)="removeRecipient(recipient)">
            @if (recipient.lastName) {
              {{ recipient.lastName }}, {{ recipient.firstName }} <{{ recipient.email }}>
            } @else if (recipient.firstName) {
              {{ recipient.firstName }} <{{ recipient.email }}>
            } @else {
              {{ recipient.email }}
            }
            <button matChipRemove [attr.aria-label]="'Remove ' + recipient.email">
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip-row>
        }
      </mat-chip-grid>
      <input
        #recipientInput
        (blur)="recipientInputOnBlur($event)"
        (keydown)="filterRecipients($event)"
        [matAutocomplete]="auto"
        [matChipInputFor]="recipientsChips"
        [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
        placeholder="Recipients" />
      <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectRecipient($event)">
        @for (recipient of filteredRecipients; track recipient) {
          <mat-option [value]="recipient">
            @if (recipient.firstName && recipient.lastName) {
              {{ recipient.lastName }}, {{ recipient.firstName }} <{{ recipient.email }}>
            } @else if (recipient.firstName) {
              {{ recipient.firstName }} <{{ recipient.email }}>
            } @else {
              <{{ recipient.email }}>
            }
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
    <mat-form-field class="w-80-2">
      <mat-label>Subject</mat-label>
      <input formControlName="subject" matInput required />
    </mat-form-field>
    <button (click)="browseFiles()" class="w-20-2 attach-file-button" color="primary" mat-stroked-button>
      <fa-icon [icon]="['far', 'paperclip']"></fa-icon>
      Attach File(s)
    </button>
    @if (attachments.length > 0) {
      @for (attachment of attachments; track $index) {
        <mat-chip-set aria-label="Dog selection">
          <mat-chip (removed)="removeAttachment($index)">
            <fa-icon matChipAvatar [icon]="['far', 'paperclip']"></fa-icon>
            {{ attachment.name }}
            <button matChipRemove>
              <mat-icon>cancel</mat-icon>
            </button>
          </mat-chip>
        </mat-chip-set>
      }
    }
    <ckeditor [editor]="editor" class="w-100-1 editor" formControlName="body"></ckeditor>
    <div class="attachments w-100-1"></div>
  </form>
</div>

<input #documentUpload [multiple]="true" style="display: none" type="file" />
